import React, { useEffect, useState } from 'react';

interface ReturnType<T = {}> {
  page: number,
  loading: boolean,
  items: Array<T>,
  isDone: boolean,
  querys: any,
  isEmpty: boolean,
  total: number,
  fetchList: () => any,
  loadMore: () => void,
  changeQuerys: (querys: any) => void
}

const useFetchList = <T>(fetchFunc: Function, initState: {
  page?: number,
  size?: number,
  querys?: any
} = {
  page: 1,
  size: 10,
  querys: {}
}): ReturnType<T> => {
  const [page, setPage] = useState(initState.page || 1)
  const [querys, setQuerys] = useState(initState.querys || {})
  const [loading, setLoading] = useState(false)
  const [isDone, setIsDone] = useState(false)
  const [items, setItems] = useState<T[]>([])
  const [total, setTotal] = useState<number>(items.length)
  const isEmpty = items.length === 0

  function fetchList() {
    const _page = page
    const _fetchFunc = fetchFunc({ 
        page: _page, 
        size: initState.size, 
        ...querys 
      })
      
    setLoading(true)
    _fetchFunc.then((data: {domains: T[], total: number }) => {
      setTotal(data.total);
      // items
      if (page === 1) {
        setItems(data.domains)
      } else {
        setItems([...items, ...data.domains])
      }

      // isDone
      if (data.domains.length === 0) {
        setIsDone(true)
      } else {
        setIsDone(false)
      }
      
      // loading
      setLoading(false)
    }).catch(() => {
      setLoading(false)
    })
  }

  function loadMore() {
    console.log('loadMore')
    if (isDone) {
      console.log('noMore')
      return
    }
    setPage(page + 1)
  }

  function changeQuerys(_query: any) {
    setPage(1)
    setQuerys({...initState.querys, ..._query})
  }

  useEffect(() => {
    fetchList()
  }, [page, querys]);

  return {
    page,
    loading,
    items,
    total,
    isDone,
    querys,
    isEmpty,
    fetchList,
    loadMore,
    changeQuerys
  };
};

export default useFetchList;